export interface EmailAliasesEditable {
  id: string;
  email: string;
  email_aliases?: (string | null)[] | null | undefined;
}

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const normalizeAliases = (aliases: (string | null)[] | null | undefined): string[] => {
  if (!aliases) return [];
  return aliases.filter((alias): alias is string => alias != null);
};

export const getEmailLocalPart = (email: string): string => email.split("@")[0];
